import { useQuery, useQueryClient } from "react-query";
import axiosInstance from "./axiosInstance";
import { ChatLabel } from "../../types/ChatListType";

export interface ChatLabelsRes {
  status: boolean;
  data: { chat_lables: ChatLabel[] };
  message: string;
}

export const useChatLabels = () => {
  const queryClient = useQueryClient();

  const { data, isLoading } = useQuery<ChatLabelsRes, Error>(
    ["chat_lable", "get"],
    async () => {
      const response = await axiosInstance.post<ChatLabelsRes>("chat_lable/get", {});
      return response.data;
    },
    {
      staleTime: 60000,
      enabled: true,
    }
  );

  const invalidate = () => queryClient.invalidateQueries(["chat_lable"]);

  return {
    data: data?.data?.chat_lables ?? [],
    isLoading,
    invalidate,
  };
};
